export function PoweredBy() {
  return (
    <p className="powered-by">
      Powered by{" "}
      <a href="https://tacklit.com" target="_blank" rel="noopener noreferrer">
        Tacklit
      </a>
    </p>
  );
}
